const initialState = {
  bySameAuthor: [],
  inSameCategory: []
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'RECOMMENDED_STORIES_FETCH_DATA_SUCCESS':
      return {
        bySameAuthor: action.recommendedStories.by_same_author,
        inSameCategory: action.recommendedStories.in_same_category
      };
    default:
      return state;
  }
};